import HTTP from '../../Infra/Http'



export const createPlan = async (planData) => {
  return await HTTP.Post('/api/plans/admin/', planData);
};

export const updatePlan = async (id,planData) => {
  return await HTTP.Put('/api/plans/admin/'+id, planData);
};

export const deletePlan = async (id) => {
  return await HTTP.Delete(`/api/plans/admin/${id}`);
};

export const getAllPlansAdmin = async () => {
  return await HTTP.Get('/api/plans/admin/all');
};

